import React from 'react';

const TimeSelect = ({
    value,
    onChange,
    placeholder = "Select time",
    isDisabled = false,
    error,
    helperText,
}) => {
    return (
        <div>
            <input
                type="time"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={isDisabled}
                placeholder={placeholder}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                style={{
                    borderRadius: '8px',
                    border: error ? '2px solid #dc3545' : '1px solid #ced4da',
                    height: '38px',
                    padding: '0 12px',
                    fontSize: '0.85rem',
                }}
            />

            {error && helperText && (
                <small className="text-danger d-block mt-1" style={{ fontSize: '0.75rem', marginLeft: '0.25rem' }}>
                    {helperText}
                </small>
            )}
        </div>
    );
};

export default TimeSelect;